import { IcAlert, IcButton } from "@ukic/react";
import { ApiError } from "../api";

/** Render an API/network error using an ICDS alert, with optional retry. */
export function ErrorState({
  error,
  onRetry,
}: {
  error: unknown;
  onRetry?: () => void;
}) {
  const isAuth = error instanceof ApiError && error.isAuth;
  const heading = isAuth
    ? "Your session needs to be re-authenticated"
    : "Something went wrong";
  const message =
    error instanceof ApiError
      ? error.message
      : error instanceof Error
        ? error.message
        : String(error);

  return (
    <div className="hl-center-pad">
      <IcAlert variant="error" heading={heading} message={message}>
        <div slot="action">
          {isAuth ? (
            <IcButton onClick={() => window.location.reload()}>Reload</IcButton>
          ) : onRetry ? (
            <IcButton onClick={onRetry}>Retry</IcButton>
          ) : null}
        </div>
      </IcAlert>
    </div>
  );
}
